<template>
  <paginator :total-count="totalCount" :page-size="pageSize" :active-page="currentPage"
             @pageActivated="pageActivated"/>
</template>

<script>
import Paginator from '../paginator/Paginator'
import { mapState } from 'vuex'
import { SET_COMPANY_CARDS_CURRENT_PAGE_NUMBER } from '../../store/modules/card/mutation-types'

export default {
  name: 'CardListPaginator',
  components: {
    Paginator
  },
  props: {
    pageSize: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState({
      cards: state => state.card.companyCardsForCurrentFilter,
      totalCount:
        state => state.card.totalNoCompanyCardsForCurrentFilter ? state.card.totalNoCompanyCardsForCurrentFilter : 0,
      currentPage: state => state.card.companyCardsCurrentPageNumber
    })
  },
  methods: {
    pageActivated: function (pageNumber) {
      this.$store.commit(`card/${SET_COMPANY_CARDS_CURRENT_PAGE_NUMBER}`, {number: pageNumber})
      this.$emit('paginationChanged')
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/cards/CardListPaginator.vue